<div class=" banner_header">
    <div class="col-md-12">
        <h2>CTS CBT Main Exam AITT-2022</h2>
    </div>
</div>

<!--Content Start-->
<section class="section_box_one">
    <div class="container">
        <!-- <h2>Fees Payment Link For Phase 16 </h2> -->
        <h2>Fee payment link </h2>
        <!--activated from 5
                PM 21th June 2021 to 14 July 2021. | RPL Supplementary Exam Registration - <a
                    href="https://nimionlineadmission.in/rplexam2/" target="_blank"> Click Here </a>-->
        <!-- <marquee>
            <h3>

                Fee payment link for leftover trainees of AITT (2020) will be closed by midnight 22nd July
            </h3>
        </marquee> -->
    </div>
</section>
<!--Content End-->

<div class="container payment_cls">

    <div class="row">
        <div class="col-md-4 step_cls">
            <h3> Payment link for Regular leftover trainees for the First year of 2019-21, 2019-20, and 2018-20 </h3>
            <!-- <p> candidates can pay individually using their Roll Number. After Payment, candidate will recive a
                confirmation mail from the payment gateway cc avenue and a payment receipt from NIMI PORT. If you have
                receive any one of the mails, kindly do not repay. IT WILL BE UPDATED WITHIN 48 HRS.</p> -->
 
            <!-- <a class="click_here" target="_blank" href="https://www.nimionlineadmission.in/AITTCBT-FEES16/"> Click Here
            </a> -->
            <!-- <a class="click_here" target="_blank" href="https://nimionlineadmission.in/AITTCBT-FEES22/"> Click Here
            </a> -->
        </div>
        <div class="col-md-4 step_cls">
            <h3>
                Payment link for supplementary trainees of Batch 2018-19,  First year of 2019-21, Second year of 2018-20, batch of 2019-20 & trainee who raised the grievance
            </h3>
           
            <!-- <a class="click_here" target="_blank"
                href="https://www.nimionlineadmission.in/AITTCBT-FEES16/indexbulk.php"> Click Here </a> -->
            <!-- <a class="click_here" target="_blank"
                href="https://nimionlineadmission.in/wipro_supplementary/" >Click Here </a> -->
        </div>
        <div class="col-md-4 step_cls">
            <h3> Payment link for the supplementary First year of 2018-20 two-year trade

            </h3>
           
            <!-- <a class="click_here" target="_blank"
                href="https://www.nimionlineadmission.in/AITTCBT-FEES16/indexbulk.php"> Click Here </a> -->
            <!-- <a class="click_here"  target="_blank"
                href="https://nimionlineadmission.in/wipro_sup2018" >Click Here </a> -->
        </div>

    </div>

    <hr>


    <div class="row">
        <!-- <div class="col-md-6 step_cls">
            <h3> Individual Payment </h3>
            <p>
                candidates can pay individually using their Roll Number. After making Payment, candidate will receive a
                confirmation mail from the payment gateway CC Avenue and a payment receipt from NIMI Portal. If you have
                received any one of the mails, kindly do not repay. IT WILL BE UPDATED WITHIN 48 HRS.
            </p>
    
            <a class="click_here" target="_blank" href="https://nimionlineadmission.in/AITTCBT-FEES22/"> Click Here
            </a>
        </div>
        <div class="col-md-6 step_cls">
            <h3> Bulk Payment </h3>
           
            <p>
                Institutes can pay in bulk for more than two candidates using their institute MIS CODE. After Payment,
                Candidate will recive a confirmation mail from the payment gateway CC Avenue and a payment receipt from
                NIMI Portal. If you have recived any one of the mails, kindly do not repay. IT WILL BE UPDATED WITHIN 48
                HRS.
            </p>
          
            <button class="click_here" style="background-color: #999;" target="_blank"
                href="https://www.nimionlineadmission.in/AITTCBT-FEES16/indexbulk.php" disabled>Click Here </button>
        </div> -->
        <div class="col-md-12 step_cls">
            <br>
            <p style="color: red; font-weight: bold; font-style: italic;">
                “Dear Trainee, it is to inform that due to technical reason CTS CBT examination schedule on 14 September 2021 is postponed . Fresh examination date for already scheduled trainees will be announced shortly”
            </p>
            <!-- <p> If you have paid your fees already <a style="color: red; font-weight: bold;" routerLink="/priForm">
                    click
                    here </a> </p> -->
            <!-- <p>
              If you have not attended Dec to April 2021 CBT examination but paid the fees in previous phases, Please update your payment details <a style="color: red; font-weight: bold;" routerLink="/priForm">
                click
                here </a>
            </p> -->
            <!-- <p>Fee payment link will be closed by midnight 11 July 2021</p> -->
            <!-- <p> If you have paid the fees and wish to check your payment status <a target="_blank" style="color: red; font-weight: bold;"
              href="https://nimionlineadmission.in/AITTCBT-FEES22/paidlist.php">
                    click
                    here </a> </p> -->

                    <!-- <p> payemnt verified list <a style="color: red; font-weight: bold;"
                      routerLink="/verifyreport">
                      click
                      here </a> </p> -->
            <h4 style="color: red; font-style: italic; font-weight: bold;">Fee link for leftover trainees will be closed
                11th August 2021
                midnight </h4>
            <!-- <p style="color: red; font-style: italic;">Fee link for supplementary candidates shall be opened separately
            </p>
            <p style="color: red; font-style: italic;">
              <b> Note: </b> Left over trainees-Trainees who could not attend previous phases of CBT examination
            </p> -->
            <!-- <p style="color: red; font-style: italic;">Due to administrative reasons the exam payment link for
                supplementary candidates is suspended temporarily. It will be resumed later. </p> -->

        </div>
    </div>

</div>




<style>
    .section_box_one {
        padding: 30px 0px;
    }

    .section_box_one h2 {
        border-bottom: 5px solid #000;
        padding-bottom: 5px;
        width: fit-content;
        margin: 0 auto 30px;
    }

    .banner_header {
        background: #2955a9;
        padding: 10px 0px;
        text-align: left;
        color: #fff;
        margin: 0px;
    }

    .banner_header h2 {
        font-size: 21px;
    }

    .download_section {
        padding: 40px 0px;
        text-align: center;
    }

    .steps {
        left: 0px;
        height: 50px;
        width: 50px;
        background-color: #29ab55;
        border-radius: 50%;
        display: inline-block;
        font-size: 31px;
        text-align: center;
        color: #fff;
        position: absolute;
    }

    .step_cls {
        padding: 0px 70px 0px;
    }

    .click_here {
        background: #2955a9;
        padding: 5px 15px;
        color: #fff;
        font-size: 21px;
        font-weight: 500;
        border-radius: 10px;
        width: fit-content;
        cursor: pointer;
    }

    .click_here:hover {
        background-color: #000;
    }

    .payment_cls {
        padding: 30px 0px 120px;
    }
</style>
